var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__role"},[_c('div',{staticClass:"modal__content"},[_c('p',{staticClass:"modal__text",domProps:{"innerHTML":_vm._s(
        _vm.tasks[`role_${_vm.getActiveGame}`][`question_${_vm.getActiveRound + 1}`][
          `option_${_vm.getModalProps.number}`
        ].result
      )}}),_c('p',{staticClass:"security__number"},[_vm._v(" Рівень безпеки: "),_c('span',[_vm._v("+"+_vm._s(_vm.tasks[`role_${_vm.getActiveGame}`][`question_${_vm.getActiveRound + 1}`][ `option_${_vm.getModalProps.number}` ].scores))])]),_c('ButtonBase',{staticClass:"modal__control",on:{"click":_vm.next}},[_vm._v(" Зрозуміло ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }